import type { QueryClient } from "@tanstack/react-query";
import { type LoaderFunctionArgs, defer } from "react-router-dom";
import { getOrganizationOptions } from "../../../services";
import { getAssignmentsOptions } from "../../../services/organtization/assignment/get-assignments";

export const buildAssignmentsLoader =
  (queryClient: QueryClient) =>
  async ({ params }: LoaderFunctionArgs) => {
    if (!params.organizationId) throw new Error("Organization ID is required");

    return defer({
      organization: queryClient.ensureQueryData(
        getOrganizationOptions(params.organizationId),
      ),
      assignments: queryClient.ensureQueryData(
        getAssignmentsOptions(params.organizationId),
      ),
    });
  };
